(function(){
  'use strict';
  var startedGuided=new URLSearchParams(location.search||'').get('edg_guided')==='1';
  var editingBuild=new URLSearchParams(location.search||'').get('edg_edit');
  function preserveGuidedUrl(value){
    if(!startedGuided||value==null)return value;
    try{
      var url=new URL(String(value),location.href);
      if(url.origin!==location.origin)return value;
      url.searchParams.set('edg_guided','1');
      if(editingBuild&&url.pathname===location.pathname)url.searchParams.set('edg_edit',editingBuild);
      return url.pathname+url.search+url.hash;
    }catch(error){return value;}
  }
  if(startedGuided){
    var originalReplaceState=history.replaceState.bind(history);
    var originalPushState=history.pushState.bind(history);
    history.replaceState=function(state,title,url){return originalReplaceState(state,title,preserveGuidedUrl(url));};
    history.pushState=function(state,title,url){return originalPushState(state,title,preserveGuidedUrl(url));};
  }
  function guided(){return new URLSearchParams(location.search||'').get('edg_guided')==='1';}
  function kind(value){var v=String(value||'').toLowerCase();if(v.indexOf('mini')>=0)return'mini';if(v.indexOf('ultra')>=0)return'ultra';if(v==='fi 2'||v.indexOf('series 2')>=0)return'2';if(v.indexOf('3+')>=0)return'3plus';if(v.indexOf('series 3')>=0)return'3';return'';}
  function go(path){if(location.pathname!==path)location.replace(path+'?edg_guided=1');}
  function check(attempt){
    if(!guided()||editingBuild)return;
    var session=window.EDGBuildSession;
    if(!session){if((attempt||0)<50)setTimeout(function(){check((attempt||0)+1);},60);return;}
    var dog=session.activeDog?session.activeDog():null;if(!dog)return;
    var handle=(location.pathname.match(/\/products\/([^/?#]+)/)||[])[1]||'';
    var k=kind(dog.fiSeries);
    if(handle==='fi-traditional-buckle-collar'&&(k==='mini'||k==='ultra')){go('/products/traditional-buckle-collar');return;}
    if(handle==='fi-martingale-collar'&&(k==='mini'||k==='ultra')){go('/products/martingale-collar');return;}
    if(handle==='fi-arctic-circle-collar'&&(k==='mini'||k==='ultra')){go('/products/arctic-circle-collar');return;}
    if(handle==='fi-signature-canvas-collar'&&(k==='mini'||k==='ultra')){go('/products/signature-canvas-collar');return;}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){check(0);});else check(0);
  document.addEventListener('shopify:section:load',function(){check(0);});
})();

